/**
 * List of supported Ad Providers
 * @param options object of options to build the list
 * @param options.includeEmpty boolean to include an empty name/value pair at the beginning
 * @param options.emptyData object of data to spread into the empty name/value pair if includeEmpty is true
 */
export function list(options = {}) {
  const list = [
    {
      label: 'Good Vibes',
      value: 'goodvibes',
      orderTypes: ['always-on-pmp', 'programmatic'],
    },
    {
      label: 'Koddi',
      value: 'koddi',
      orderTypes: ['always-on-pmp', 'programmatic'],
    },
    {
      label: 'Place Exchange',
      value: 'place-exchange',
      orderTypes: ['always-on-pmp', 'programmatic', 'direct', 'direct-ext'],
    },
    {
      label: 'Triton',
      value: 'triton',
      orderTypes: [],
    },
    {
      label: 'Vibenomics',
      value: 'vibenomics',
      orderTypes: ['direct', 'direct-ext'],
    },
    {
      label: 'Vistar',
      value: 'vistar',
      orderTypes: ['always-on-pmp', 'programmatic'],
    },
  ];

  if (options.includeEmpty === true) {
    const emptyData = options.emptyData ?? {};

    list.unshift({
      label: '',
      value: '',
      orderTypes: [],
      ...emptyData,
    });
  }

  return list;
}

export default {
  list,
};
